/**
 * HorizontalScrollView - H5 版本
 * 横向滚动容器
 */
import React from 'react';

export interface HorizontalScrollViewProps {
  className?: string;
  /** 小程序端内层 flex 容器的 className，H5 端忽略 */
  innerClassName?: string;
  children?: React.ReactNode;
  /** 小程序端专用，H5 端忽略 */
  scrollIntoViewId?: string;
}

export const HorizontalScrollView: React.FC<HorizontalScrollViewProps> = ({
  className,
  children,
}) => (
  <div className={className}>
    {children}
  </div>
);

export default HorizontalScrollView;
